
import { PreparationDocumentDto, CreatePreparationDocumentDto, UpdatePreparationDocumentDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { preparationDocumentService, PreparationDocumentsFilters } from '@services/PreparationDocumentService'

const { reducer, actions, thunks } = baseCrudReducer<
  PreparationDocumentDto,
  CreatePreparationDocumentDto,
  UpdatePreparationDocumentDto,
  PreparationDocumentsFilters
>('preparationDocument', preparationDocumentService)

export default reducer

export const { setFilters: setPreparationDocumentFilters } = actions

export const {
  getAll: getPreparationDocuments,
  create: createPreparationDocument,
  update: updatePreparationDocument,
  remove: removePreparationDocument,
} = thunks
